export default () =>
  import(/* webpackChunkName: 'coffee/app/join-us/list' */ './JoinUsList');
